export const MINIMAX_M27_MODEL_REF = "openrouter/minimax/minimax-m2.7";
export const MINIMAX_M27_OPENROUTER_MODEL_ID = "minimax/minimax-m2.7";
export const MINIMAX_M3_MODEL_REF = "openrouter/minimax/minimax-m3";
export const MINIMAX_M3_OPENROUTER_MODEL_ID = "minimax/minimax-m3";

const MINIMAX_OPENROUTER_MODEL_REFS = new Set([
  MINIMAX_M27_MODEL_REF,
  MINIMAX_M3_MODEL_REF,
]);

export function isMiniMaxM27ModelRef(
  modelRef: string | null | undefined,
): boolean {
  return modelRef?.trim() === MINIMAX_M27_MODEL_REF;
}

export function isMiniMaxOpenRouterModelRef(
  modelRef: string | null | undefined,
): boolean {
  const trimmed = modelRef?.trim();
  return trimmed !== undefined && MINIMAX_OPENROUTER_MODEL_REFS.has(trimmed);
}
